var app = angular.module('storefrontApp');
app.controller('topPicksController', 
    ['$rootScope', '$scope', '$location', 'topPicksElasticService', "randomService", "commonService", "configs",
    function ($rootScope, $scope, $location, elasticService, randomService, commonService, configs) {
    
        $scope.size = 50;
        $scope.topPicksPool = [];
        $scope.requiredSize = 75;
        $scope.matchPercent = 70;
        $scope.definitionNames = [];
        $scope.viewedProductInfo = [];

        $scope.getShippableProducts = function () {
            commonService.getElasticData(configs.elasticBaseUrl, elasticService.buildShippableProductsRequest()).then(
                function (response) {
                    $scope.topPicksPool = $scope.topPicksPool.concat(response.data.hits.hits);
                    $scope.topPicks = randomService.getRandomItems($scope.topPicksPool);
                }
            ); 
        }
        
        function getDefaultTopPicks(){
            var defaultTopPicks = [];
            commonService.getElasticData(configs.elasticBaseUrl, elasticService.buildDefaultTopPicksRequest()).then(
                function (response) {
                    if (response && 'aggregations' in response.data) {
                        var responseData = response.data.aggregations.definitions.buckets;
                        angular.forEach(responseData, function (bucket) {
                            defaultTopPicks = defaultTopPicks.concat(bucket.topByDefinitions.hits.hits);
                        });
                        $scope.topPicksPool = $scope.topPicksPool.concat(defaultTopPicks);
                        $scope.getShippableProducts();
                    }
                }
            );
        }
        
        function getPatchDefaultTopPicks(prdId){
            var defaultTopPicks = [];
            commonService.getElasticData(configs.elasticBaseUrl, buildPatchRequest(prdId)).then(
                function (response) {
                    if (response && 'aggregations' in response.data) {
                        var responseData = response.data.aggregations.definitions.buckets;
                        angular.forEach(responseData, function (bucket) {
                            defaultTopPicks = defaultTopPicks.concat(bucket.topByDefinitions.hits.hits);
                        });
                        $scope.topPicksPool = $scope.topPicksPool.concat(defaultTopPicks);
                        $scope.topPicks = randomService.getRandomItems($scope.topPicksPool);
                    }
                }
            );
        }

        $scope.getTopPicks = function(prdId){
            var productIds = [];
            if(angular.isDefined(prdId) && prdId.length > 0){
                $scope.isProductPage = true;
                productIds.push(prdId);
                getRelatedProductInfo(productIds);
            }
            else{
                var recentlyViewed = localStorage.getItem("recentlyViewed");
                if(angular.isDefined($rootScope.customerCartRS) && $rootScope.customerCartRS.length > 0 && $rootScope.isCartPage){
                    var idsToRemove = ["gc", "cd"];
                    productIds = $rootScope.customerCartRS.filter(function (el) {
                        return idsToRemove.indexOf(el.toLowerCase()) < 0;
                    });
                    if(productIds.length > 0){
                        $scope.matchPercent = 10;
                        $scope.loadShippables = true;
                        getRelatedProductInfo(productIds);
                    }
                    else{
                        getDefaultTopPicks();
                    }
                }
                else if(recentlyViewed != null){
                    if(!(angular.isUndefined(recentlyViewed) && recentlyViewed !== null)){
                        angular.forEach(recentlyViewed.split(','), function(product){
                            productIds.push(product);
                        });
                    }
                    getRelatedProductInfo(productIds);
                }
                else {
                    getDefaultTopPicks();
                }
            }
        }

        $scope.getPatchTopPicks = function(prdId){
            getPatchDefaultTopPicks(prdId);
        }

        function getRelatedProductInfo(productIds){
            commonService.getElasticData(configs.elasticBaseUrl, elasticService.buildProductByIdsRequest(angular.toJson(productIds))).then(
                function (response) {
                    if (response) {
                        angular.forEach(response.data.hits.hits, function (res) {
                            if (jQuery.inArray(res._source.definitionName, $scope.definitionNames) == -1)
                                if(angular.isDefined(res._source.definitionName))
                                {
                                    $scope.definitionNames.push(res._source.definitionName);
                                }
                            }
                        );
                        $scope.viewedProductInfo = response.data.hits.hits;
                        if($scope.viewedProductInfo.length > 0){
                            $scope.getRelatedProducts($scope.viewedProductInfo);
                        }
                        else{
                            getDefaultTopPicks();
                        }
                    }
                }
            );
        }

        $scope.getRelatedProducts = function (products) {
            commonService.getElasticData(configs.elasticBaseUrl, buildRequest(products)).then(
                function(response){
                    if(response && 'aggregations' in response.data){
                        $scope.count = response.data.hits.total.value;
                        var data = response.data.aggregations.definitions.buckets;
                        if($scope.isProductPage){
                            $scope.requiredSize = 4;
                        }
                        if ($scope.count <= $scope.requiredSize && $scope.matchPercent > 10) {
                            $scope.matchPercent = $scope.matchPercent - 10;
                            $scope.getRelatedProducts($scope.viewedProductInfo );
                        }
                        else if ($scope.count <= $scope.requiredSize && $scope.matchPercent == 10) {
                            angular.forEach(data, function(d){
                                $scope.topPicksPool = $scope.topPicksPool.concat(d.topByDefinitions.hits.hits);
                            });
                            if($scope.isProductPage && $scope.topPicksPool.length > 3){
                                $scope.topPicks = randomService.getRandomItems($scope.topPicksPool);
                            }
                            else{
                                getDefaultTopPicks();
                            }
                        }
                        else{
                            angular.forEach(data, function(d){
                                $scope.topPicksPool = $scope.topPicksPool.concat(d.topByDefinitions.hits.hits);
                            });
                            if($scope.loadShippables){
                                $scope.getShippableProducts();
                            }
                            else{
                                $scope.topPicks = randomService.getRandomItems($scope.topPicksPool);
                            }
                        }
                    }
                }
            )
        }

        function buildRequest(result) {
            var EXCLUDED_FIELDS = [
                "*.productTabContent",
                "*.mainFeatures",
                "variants.associatedItemsList",
                "variants.associatedItems",
                "categories",
                "categoriesList",
                "variants.fTA",
                "designKeywords",
                "keywords",
                "colorSequence",
                "variants.fileTypesAvailable"
            ];

            var moreLikeThis = {
                fields: ["keywords", "name"],
                like: [],
                min_term_freq: 1,
                min_doc_freq: 5,
                max_query_terms: 100,
                minimum_should_match: $scope.matchPercent + "%"
            };

            var filters = [
                { range: { listPrice: { gt: 1.99 } } },
                { term: { inStock: true } }
            ];
            if ($rootScope.isPatchEligible) {
                filters.push({ term: { "variants.isPatchEligible": true } });
            }

            var shouldDefinitions = [];

                angular.forEach($scope.definitionNames, function (def) {
                
                    shouldDefinitions.push({ term: { definitionName: def } });
                });


            angular.forEach(result, function (doc) {
                moreLikeThis.like.push({ _id: doc._id });
            });

            var request = {
                track_total_hits: true,
                sort: [
                    { rating: "desc" },
                    { saleRank: "desc" }
                ],
                _source: { excludes: EXCLUDED_FIELDS },
                query: {
                    function_score: {
                        query: {
                            bool: {
                                must: { more_like_this: moreLikeThis },
                                filter: {
                                    bool: {
                                        must: [
                                            { bool: { should: shouldDefinitions } }
                                        ].concat(filters)
                                    }
                                }
                            }
                        },
                        functions: [
                            {
                                field_value_factor: {
                                    field: "saleRank",
                                    factor: 1.5,
                                    modifier: "sqrt",
                                    missing: 0
                                }
                            }
                        ],
                        boost_mode: "sum"
                    }
                },
                size: 0,
                aggs: {
                    definitions: {
                        terms: { 
                            field: "definitionName",
                        },
                        aggs: {
                            topByDefinitions: {
                                top_hits: {
                                    size: $scope.size,
                                    _source: { excludes: EXCLUDED_FIELDS }
                                }
                            }
                        }
                    }
                }
            };
            return angular.toJson(request);
        }

        function buildPatchRequest(result) {
            var EXCLUDED_FIELDS = [
                "*.productTabContent",
                "*.mainFeatures",
                "variants.associatedItemsList",
                "variants.associatedItems",
                "categories",
                "categoriesList",
                "variants.fTA",
                "designKeywords",
                "keywords",
                "colorSequence",
                "variants.fileTypesAvailable"
            ];

            var moreLikeThis = {
                fields: ["keywords", "name"],
                like: [{ _id: result }],
                min_term_freq: 1,
                min_doc_freq: 5,
                max_query_terms: 100,
                minimum_should_match: "60%"
            };

            var filters = [
                { range: { listPrice: { gt: 0 } } },
                { term: { "variants.isPatchEligible": true } }
            ];

            var request = {
                track_total_hits: true,
                sort: [
                    { rating: "desc" },
                    { saleRank: "desc" }
                ],
                _source: { excludes: EXCLUDED_FIELDS },
                query: {
                    function_score: {
                        query: {
                            bool: {
                                must: { more_like_this: moreLikeThis },
                                filter: {
                                    bool: {
                                        must: filters
                                    }
                                }
                            }
                        },
                        functions: [
                            {
                                field_value_factor: {
                                    field: "saleRank",
                                    factor: 1.5,
                                    modifier: "sqrt",
                                    missing: 0
                                }
                            }
                        ],
                        boost_mode: "sum"
                    }
                },
                size: 0,
                aggs: {
                    definitions: {
                        terms: {  field:"definitionName"},
                        aggs: {
                            topByDefinitions: {
                                top_hits: {
                                    size: $scope.size,
                                    _source: { excludes: EXCLUDED_FIELDS }
                                }
                            }
                        }
                    }
                }
            };

            return angular.toJson(request);
        }

        $scope.navigateToPatchPage = function(url){
            location.href = url;
        }
    }
]);
